import * as _ from 'underscore';
import { UIElement } from './uiElement';
import { Table } from '../../table';
import { DataSource } from '../../data';
import {
	SelectionOptions,
	TableUIElementOptions,
	IUIElementOptions
} from '../../../interfaces/options';
import { Templates } from '../../../compile';
import { IEvent } from 'mappMvc/interfaces';

export class TableUIElement<T> extends UIElement<T> {
	public table: Table<T>;
	private hasValue: KnockoutObservable<any>;
	public get selectedItems(): T[] {
		return this.table.selectedItems;
	}
	public selectionCount: KnockoutComputed<number>;
	//autoComplete
	private autoCompleteFilter: boolean;
	private textInput: KnockoutObservable<string>;
	private textInputThrottled: KnockoutComputed<string>;

	public get onSelectionToggled(): IEvent<T[]> {
		return this.table.onSelectionToggled;
	}
	constructor(options: TableUIElementOptions<T>) {
		options.uiElement = $.extend(
			true,
			{},
			<IUIElementOptions>{
				widget: {
					widget: Templates.widgets_formTable
				}
			},
			options.uiElement || {}
		);
		options = $.extend(
			true,
			{},
			<TableUIElementOptions<T>>{ autoCompleteFilter: false },
			options || {}
		);
		var hasValue = ko.observable<any>();
		super(options.id, options.label, hasValue, options.uiElement);
		this.table = new Table<T>(options.table);
		this.hasValue = hasValue;
		this.onSelectionToggled.subscribe(selections => {
			this.hasValue(this.table.selectionCount() > 0 ? true : null);
		});
		this.selectionCount = this.table.selectionCount;
		//autoComplete Filter
		this.textInput = ko.observable<string>('');
		this.textInputThrottled = ko.computed<string>(this.textInput);
		this.autoCompleteFilter = false;
		if (!_.isNaN(options.autoCompleteFilter)) {
			if (_.isBoolean(options.autoCompleteFilter) && options.autoCompleteFilter) {
				this.autoCompleteFilter = true;
			} else if (_.isNumber(options.autoCompleteFilter) && options.autoCompleteFilter > 0) {
				this.autoCompleteFilter = true;
				this.textInputThrottled.extend({ throttle: options.autoCompleteFilter });
			}
		}
		if (this.autoCompleteFilter) {
			this.textInputThrottled.subscribe((newValue: string) => {
				this.table.reload(newValue);
			});
		}
	}
	public reload(selection?: SelectionOptions<T>, ...params: any[]): Promise<DataSource<T>> {
		return this.table.reload(params).then(datasource => {
			if (selection) {
				this.selectItems(selection.items, selection.property);
			}
			return Promise.resolve(datasource);
		});
	}
	public selectItem(item: T | string, property: string) {
		this.table.selectItem(item, property);
	}
	public selectItems(items: T[] | string[], property: string) {
		this.table.selectItems(items, property);
	}
	public clearSelection() {
		this.table.clearSelection();
	}
	public reset() {
		this.textInput(null);
		this.clearSelection();
		this.table.dataSource.data.removeAll();
	}

	public selectAll() {
		this.table.selectAll();
	}
}
